/* Copyright 2013 - 2024 Waiterio LLC */
const chromium = typeof chrome !== 'undefined'

export default chromium
